import { useCart } from 'src/components/Cart/UseCart';

export const useTax = () => {
  const { checkout } = useCart();

  const isTaxSet = !!(checkout.tax && checkout.tax !== null);
  const taxPrice = checkout.tax ? +(checkout.subtotal * (checkout.tax / 100)).toFixed(2) : 0;

  return { isTaxSet, taxPrice };
};
